import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

// Filter out noisy SES/lockdown and ResizeObserver errors at the console level
if (typeof window !== "undefined" && typeof console !== "undefined") {
  const originalError = console.error;
  const originalWarn = console.warn;

  console.error = (...args) => {
    const message = args.map(arg =>
      typeof arg === "string" ? arg :
        (arg && typeof arg === "object" && arg.message) ? arg.message :
          String(arg)
    ).join(" ");

    if (
      message.includes("SES_UNCAUGHT_EXCEPTION: null") ||
      message.includes("ResizeObserver loop completed with undelivered notifications")
    ) {
      return; // Suppress these known benign errors
    }

    originalError.apply(console, args);
  };

  console.warn = (...args) => {
    const message = args.map(arg =>
      typeof arg === "string" ? arg :
        (arg && typeof arg === "object" && arg.message) ? arg.message :
          String(arg)
    ).join(" ");

    if (
      message.includes("SES_UNCAUGHT_EXCEPTION: null") ||
      message.includes("ResizeObserver loop completed with undelivered notifications")
    ) {
      return; // Suppress these known benign warnings
    }

    originalWarn.apply(console, args);
  };
}

ReactDOM.render(
  // <React.StrictMode>
  <App />,
  // </React.StrictMode>,
  document.getElementById("root")
);

// Help surface the root cause of masked exceptions (e.g., SES taming)
if (typeof window !== "undefined") {
  window.addEventListener("error", (event) => {
    const msg = (event && (event.message || (event.error && event.error.message))) || "";
    if (msg && msg.includes("SES_UNCAUGHT_EXCEPTION: null")) {
      return;
    }
    if (msg && msg.includes("ResizeObserver loop completed with undelivered notifications")) {
      // Known benign Chrome/ResizeObserver warning; ignore to reduce noise
      return;
    }
    // eslint-disable-next-line no-console
    console.error("GlobalError:", event.error || event.message, event);
  });
  window.addEventListener("unhandledrejection", (event) => {
    const reason = event && event.reason;
    const msg = (reason && (reason.message || String(reason))) || "";
    if (msg && msg.includes("SES_UNCAUGHT_EXCEPTION: null")) {
      return;
    }
    if (msg && msg.includes("ResizeObserver loop completed with undelivered notifications")) {
      return;
    }
    // eslint-disable-next-line no-console
    console.error("UnhandledRejection:", reason || event, event);
  });
}
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
